import PropTypes from 'prop-types';
import { color as themeColor } from '../../../app/theme';

function IconTrigger({ className, backgroundColor }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="z4fp8ezsba"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="13"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.677 8.182c.242 0 .424.121.545.364.121.181.06.424-.06.606l-6.056 7.272a.55.55 0 0 1-.484.243c-.06 0-.182 0-.242-.06-.243-.061-.424-.364-.364-.607l.545-4.182H4.778a.636.636 0 0 1-.545-.303c-.121-.242-.06-.485.06-.667l6.055-7.272a.577.577 0 0 1 .727-.182c.242.06.424.364.363.606l-.545 4.182h4.784zm-4.844 3.09-.364 2.789 3.876-4.667h-4.178a.654.654 0 0 1-.424-.182 1.143 1.143 0 0 1-.121-.485l.303-2.788-3.876 4.667h4.178c.182 0 .364.06.485.182.06.121.12.303.12.485z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#z4fp8ezsba)">
        <path fill={backgroundColor} d="M0 0h20v20H0z" />
      </g>
    </svg>
  );
}

IconTrigger.defaultProps = {
  className: undefined,
  backgroundColor: themeColor.$18,
};

IconTrigger.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default IconTrigger;
